/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // Npm: Apollo client for handling graphql request.

/*
 * EXPORTS
 */
export default gql`
  mutation ScriptDeleteMutation($scriptId: ID!) {
    ScriptDelete(scriptId: $scriptId) {
      id
      message
      name
      scriptCode
      status
      createdAt
    }
  }
`;
